export default __webpack_public_path__ + "static/screver-btq-preview-84b53512b8c82fe420869fbcfab28f8a.jpeg";